// extracted by mini-css-extract-plugin
export default {"tooltip":"nb6jKXY5GCpf8VeiVFsZ"};